var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "search-panel__filter-form",
      attrs: { action: "/", method: "post" }
    },
    [
      _c(
        "div",
        { staticClass: "search-panel__form-fieldset" },
        _vm._l(_vm.filters, function(filter, index) {
          return _c(
            "div",
            { key: index, staticClass: "search-panel__filter-item" },
            [
              _vm.isCheckboxFilter(filter.type)
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "mini-chooser__filter mini-chooser__buttons-group"
                      },
                      _vm._l(filter.items, function(item, index) {
                        return _c("CheckboxItem", {
                          key: index,
                          attrs: {
                            modify: "checkbox_theme_button",
                            name: filter.category + "[" + item.id + "]",
                            value: "" + item.id,
                            title: item.title,
                            checked: item.checked,
                            disabled: item.disabled
                          },
                          on: { change: _vm.emitSend }
                        })
                      }),
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isSliderFilter(filter.type)
                ? [
                    _c(
                      "div",
                      { staticClass: "mini-chooser__filter" },
                      [
                        _c("RangeSlider", {
                          attrs: { slider: filter, changed: _vm.priceChange },
                          on: { change: _vm.emitSend }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      !_vm.isEmpty(_vm.link)
        ? _c("ResultButton", {
            attrs: { link: _vm.link, windowWidth: _vm.windowWidth }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }